import { useMutation } from '@tanstack/react-query';

import api, { getErrorMessage } from '@/hooks/useApi';

export interface AdminUser {
  userId: string;
  email: string;
  name?: string;
  authProvider: string;
  cognitoStatus: string;
  createdAt: string;
  tokens: {
    balance: number;
    purchasedTokens: number;
    subscriptionTokens: number;
  };
}

interface LookupInput {
  type: 'email' | 'userId';
  value: string;
}

/**
 * Lookup a user by email or userId (admin only).
 * Uses mutation since this is an on-demand search, not auto-fetching.
 */
export function useLookupUser() {
  return useMutation({
    mutationFn: async (input: LookupInput) => {
      const param = input.type === 'email' ? 'email' : 'userId';
      const response = await api.get<AdminUser>(
        `/admin/users?${param}=${encodeURIComponent(input.value)}`
      );
      return response.data;
    },
    onError: (error) => {
      console.error('User lookup failed:', getErrorMessage(error));
    },
  });
}

/**
 * Delete a user account (admin only)
 */
export function useDeleteUser() {
  return useMutation({
    mutationFn: async (userId: string) => {
      await api.delete(`/admin/users/${encodeURIComponent(userId)}`);
    },
    onError: (error) => {
      console.error('Delete user failed:', getErrorMessage(error));
    },
  });
}
